module.exports = __webpack_public_path__ + "img/emoji.41680e27.png";